export default __webpack_public_path__ + "assets/ticket-component.069b0029.svg";